import { apiRequest } from './index';

const API_URL = '/api/profile/resume';

/**
 *
 * @param {string} resume the resume data
 * @param {string} filename the resume file name
 * @param {object} options options object literal
 * @param {string} options.profileMethod event property that identifies the function caller's source in profile events
 * @param {boolean} options.replaceDefault flag to replace contact's default resume or not
 * @param {string} options.responseId if response id is supplied, the resume will replace the resume used in that response
 * @param {string} options.resumeMethod event property that identifies the function caller's source in resume_create event
 * @param {string} options.useResumePredictorValidation run stricter validation that answers if the file actually looks like a resume (if re-submitting the same resume, probably set this to false)
 * @param {boolean} options.overwrite this flag looks [DEPRECATED], the perl code suggests it would replace the profile data
 * @returns {object} profile jso object
 */
export async function uploadResume(resume, filename, {
  overwrite = false,
  profileMethod = 'fe.zr-utilities.api.uploadResume',
  replaceDefault = false,
  resumeMethod = 'fe.zr-utilities.api.uploadResume',
  responseId = null,
  useResumePredictorValidation = false,
} = {}) {
  const fetchInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: JSON.stringify({
      resume,
      resume_filename: filename,
      overwrite_profile_with_resume: overwrite,
      replace_default: replaceDefault,
      enc_response_id: responseId,
      profile_method: profileMethod,
      resume_method: resumeMethod,
      use_resume_predictor_validation: useResumePredictorValidation ? 1 : 0,
    }),
  };

  const response = await apiRequest(API_URL, fetchInit);
  const json = await response.json();
  return json.data.profile;
}

export default uploadResume;
